;(function () {
  angular.module('contrast.filters').filter('timeUnit', function ($translate) {
    var transl = {
      detail_timeUnitHour_abbreviation: $translate.instant(
        'detail_timeUnitHour_abbreviation'
      ),
      detail_timeUnitMin_abbreviation: $translate.instant(
        'detail_timeUnitMin_abbreviation'
      ),
      detail_timeUnitDays: $translate.instant('detail_timeUnitDays')
    }

    return function (duration) {
      if (isNaN(parseFloat(duration)) || !isFinite(duration)) {
        return '-'
      }
      if (duration == 0) {
        return transl.detail_timeUnitMin_abbreviation
      }

      var timeDays = 60 * 60 * 24
      var timeHour = 60 * 60
      var timeMinute = 60

      var number = Math.floor(duration / timeDays)
      if (number == 0) {
        number = Math.floor(duration / timeHour)
        if (number == 0) {
          number = Math.floor(duration / timeMinute)
          return transl.detail_timeUnitMin_abbreviation
        }
        return transl.detail_timeUnitHour_abbreviation
      } else {
        return transl.detail_timeUnitDays
      }
    }
  })
})()
